import { createStore, combineReducers } from 'redux';
import projectsReducer from './projectsReducer';

const rootReducer = combineReducers({
  projectsReducer,
});

export default createStore(rootReducer);
